import React from 'react';

function forwardRef(component) {
  return React.forwardRef(component);
}

export { forwardRef };
//# sourceMappingURL=forwardRef.es.js.map
